import { Routes, Route } from 'react-router-dom'
import { Header } from './components/layout/Header'
import { Footer } from './components/layout/Footer'
import { HomePage } from './pages/HomePage'
import { TechnologyPage } from './pages/TechnologyPage'
import { SolutionsPage } from './pages/SolutionsPage'
import { ProductDetailPage } from './pages/ProductDetailPage'
import { DemoPage } from './pages/DemoPage'
import { PartnersPage } from './pages/PartnersPage'
import { DocsPage } from './pages/DocsPage'
import { ContactPage } from './pages/ContactPage'
import { WorkForcePage } from './pages/WorkForcePage'
import { WorkForceFeatureDetailPage } from './pages/WorkForceFeatureDetailPage'
import { TaskManagementFeatureDetailPage } from './pages/TaskManagementFeatureDetailPage'
import { SocialEnterpriseFeatureDetailPage } from './pages/SocialEnterpriseFeatureDetailPage'
import { MobileWorkforceFeatureDetailPage } from './pages/MobileWorkforceFeatureDetailPage'
import { AnalyticsDepartamentaisFeatureDetailPage } from './pages/AnalyticsDepartamentaisFeatureDetailPage'
import { AuthenticationFeatureDetailPage } from './pages/AuthenticationFeatureDetailPage'
import { DevelopmentNoticePage } from './pages/DevelopmentNoticePage'
import { BaresSuitePage } from './pages/BaresSuitePage'
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage'
import { TermsOfServicePage } from './pages/TermsOfServicePage'
import { AccessibilityProvider } from './components/accessibility/AccessibilityProvider'
import { SkipLink } from './components/accessibility/SkipLink'
import { ScrollToTop } from './components/common/ScrollToTop'
import './i18n/config'

function App() {
  return (
    <AccessibilityProvider>
      <div className="min-h-screen flex flex-col">
        <ScrollToTop />
        <SkipLink />
        <Header />
        <main id="main-content" className="flex-1" role="main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/technology" element={<TechnologyPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/solutions/erp-bares" element={<BaresSuitePage />} />
          <Route path="/solutions/:productId" element={<ProductDetailPage />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/docs" element={<DocsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/workforce" element={<WorkForcePage />} />
          <Route path="/workforce/feature/:featureId" element={<WorkForceFeatureDetailPage />} />
          <Route path="/task-management/feature/:featureId" element={<TaskManagementFeatureDetailPage />} />
          <Route path="/social-enterprise/feature/:featureId" element={<SocialEnterpriseFeatureDetailPage />} />
          <Route path="/mobile-workforce/feature/:featureId" element={<MobileWorkforceFeatureDetailPage />} />
          <Route path="/analytics-departamentais/feature/:featureId" element={<AnalyticsDepartamentaisFeatureDetailPage />} />
          <Route path="/authentication/feature/:featureId" element={<AuthenticationFeatureDetailPage />} />
          <Route path="/development-notice" element={<DevelopmentNoticePage />} />
          <Route path="/privacidade" element={<PrivacyPolicyPage />} />
          <Route path="/termos" element={<TermsOfServicePage />} />
        </Routes>
        </main>
        <Footer />
      </div>
    </AccessibilityProvider>
  )
}

export default App
